import React from 'react';

// 财务模块的底部按钮
const FinanceFooterBtnsCard = () => {
    return <div>FinanceFooterBtnsCard</div>;
};

export default FinanceFooterBtnsCard;
